<footer>
    <p>Firmwide Analytics</p>
    <span>&copy; 2025 Copyright owned by one or more of the KPMG International
      entities. KPMG International entities provide no services to clients.
      All rights reserved.
    </span>
  </footer>
  